import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import PropTypes from 'prop-types';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Page404({ isInner }) {
  const styledContainer = { textAlign: 'center', alignItems: 'center' };
  return (
    <>
      {!isInner && (
        <Helmet>
          <title> 404 Page Not Found |IMA </title>
        </Helmet>
      )}

      <Container>
        <StyledContent sx={isInner ? { ...styledContainer, minHeight: '100%', maxHeight: '600px' } : styledContainer}>
          <Typography variant="h3" paragraph>
            Sorry, page not found!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your
            spelling.
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          {!isInner && (
            <Button to="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button>
          )}
        </StyledContent>
      </Container>
    </>
  );
}

Page404.propTypes = {
  isInner: PropTypes.bool,
};
